export default {
    token: "TOKEN",
    currentInstituteId: "CURRENT_INSTITUTE_ID",
    publicationStartTime: "PUBLICATION_START_TIME",
    publicationRedirectUrl: "PUBLICATION_REDIRECT_URL",
}